var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-menu",class:{ 'd-block': _vm.pageOptions.pageMobileTopMenu },attrs:{"id":"top-menu"}},[_c('top-menu-nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/top-menu/TopMenu.vue?vue&type=template&id=636f77a8
// module id = null
// module chunks = 